import { createFileRoute } from '@tanstack/react-router'
import { requireSuperAdmin } from '@/lib/auth-guards'
import { AttentionReportPage } from '@/features/trainer-attention/attention-report-page'

export const Route = createFileRoute(
  '/_authenticated/trainers/attention-report'
)({
  beforeLoad: requireSuperAdmin,
  component: AttentionReportPage,
})
